import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
    setOpenTermsAndConditionsModal: (open: boolean) => void
}


export const CheckTermsAndConditionsActions = ({setOpenTermsAndConditionsModal}:Props) => {
     return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver log de control</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => setOpenTermsAndConditionsModal(true)}
          data-testid="terms-and-conditions-control-log-open"
        />
      </Flex>
    </Tooltip>
  );
}